import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=2a12d2a4"
import script from "./trash.vue?vue&type=script&lang=js"
export * from "./trash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports